import { Component, Input } from '@angular/core';
import { JobListSchema } from '@app/schemas/jobs';
import { UnderscoreToLowerPipe } from '@app/utils/string-transform.pipe';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-qualification',
  imports: [
    UnderscoreToLowerPipe,
    NgClass
  ],
  templateUrl: './qualification.component.html',
  styleUrl: './qualification.component.css'
})
export class QualificationComponent {
    @Input() job: JobListSchema = {} as JobListSchema;

}
